export default {
  "ext": "dahili",
  "country": "Ülke telefon numarası",
  "phone": "Telefon",
  "AB": "Abhazya",
  "AC": "Yükseliş Adası",
  "AD": "Andorra",
  "AE": "Birleşik Arap Emirlikleri",
  "AF": "Afganistan",
  "AG": "Antigua ve Barbuda",
  "AI": "Anguilla",
  "AL": "Arnavutluk",
  "AM": "Ermenistan",
  "AO": "Angola",
  "AQ": "Antarktika",
  "AR": "Arjantin",
  "AS": "Amerikan Samoası",
  "AT": "Avusturya",
  "AU": "Avustralya",
  "AW": "Aruba",
  "AX": "Åland Adaları",
  "AZ": "Azerbaycan",
  "BA": "Bosna Hersek",
  "BB": "Barbados",
  "BD": "Bangladeş",
  "BE": "Belçika",
  "BF": "Burkina Faso",
  "BG": "Bulgaristan",
  "BH": "Bahreyn",
  "BI": "Burundi",
  "BJ": "Benin",
  "BL": "Aziz Barthélemy",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivya",
  "BQ": "Bonaire, Sint Eustatius ve Saba",
  "BR": "Brezilya",
  "BS": "Bahamalar",
  "BT": "Butan",
  "BV": "Bouvet Adası",
  "BW": "Botsvana",
  "BY": "Beyaz Rusya",
  "BZ": "Belize",
  "CA": "Kanada",
  "CC": "Cocos (Keeling) Adaları",
  "CD": "Kongo, Demokratik Cumhuriyeti",
  "CF": "Orta Afrika Cumhuriyeti",
  "CG": "Kongo",
  "CH": "İsviçre",
  "CI": "Fildişi Sahili",
  "CK": "Cook Adaları",
  "CL": "Şili",
  "CM": "Kamerun",
  "CN": "Çin",
  "CO": "Kolombiya",
  "CR": "Kosta Rika",
  "CU": "Küba",
  "CV": "Yeşil Burun Adaları",
  "CW": "Curaçao",
  "CX": "Christmas Adası",
  "CY": "Kıbrıs",
  "CZ": "Çek Cumhuriyeti",
  "DE": "Almanya",
  "DJ": "Cibuti",
  "DK": "Danimarka",
  "DM": "Dominika",
  "DO": "Dominik Cumhuriyeti",
  "DZ": "Cezayir",
  "EC": "Ekvador",
  "EE": "Estonya",
  "EG": "Mısır",
  "EH": "Batı Sahra",
  "ER": "Eritre",
  "ES": "İspanya",
  "ET": "Etiyopya",
  "FI": "Finlandiya",
  "FJ": "Fiji",
  "FK": "Falkland Adaları",
  "FM": "Mikronezya Federal Devletleri",
  "FO": "Faroe Adaları",
  "FR": "Fransa",
  "GA": "Gabon",
  "GB": "İngiltere",
  "GD": "Grenada",
  "GE": "Gürcistan",
  "GF": "Fransız Guyanası",
  "GG": "Guernsey",
  "GH": "Gana",
  "GI": "Cebelitarık",
  "GL": "Grönland",
  "GM": "Gambiya",
  "GN": "Gine",
  "GP": "Guadeloupe",
  "GQ": "Ekvator Ginesi",
  "GR": "Yunanistan",
  "GS": "Güney Georgia ve Güney Sandwich Adaları",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Gine-Bissau",
  "GY": "Guyana",
  "HK": "Hong Kong",
  "HM": "Heard Adası ve McDonald Adaları",
  "HN": "Honduras",
  "HR": "Hırvatistan",
  "HT": "Haiti",
  "HU": "Macaristan",
  "ID": "Endonezya",
  "IE": "İrlanda",
  "IL": "İsrail",
  "IM": "Man Adası",
  "IN": "Hindistan'da",
  "IO": "İngiliz Hint Okyanusu Bölgesi",
  "IQ": "Irak",
  "IR": "İran",
  "IS": "İzlanda",
  "IT": "İtalya",
  "JE": "Jersey",
  "JM": "Jamaika",
  "JO": "Ürdün",
  "JP": "Japonya",
  "KE": "Kenya",
  "KG": "Kırgızistan",
  "KH": "Kamboçya",
  "KI": "Kiribati",
  "KM": "Komorlar",
  "KN": "Saint Kitts ve Nevis",
  "KP": "Kuzey Kore",
  "KR": "Güney Kore",
  "KW": "Kuveyt",
  "KY": "Cayman Adaları",
  "KZ": "Kazakistan",
  "LA": "Laos",
  "LB": "Lübnan",
  "LC": "Saint Lucia",
  "LI": "Lihtenştayn",
  "LK": "Sri Lanka",
  "LR": "Liberya",
  "LS": "Lesotho",
  "LT": "Litvanya",
  "LU": "Lüksemburg",
  "LV": "Letonya",
  "LY": "Libya",
  "MA": "Fas",
  "MC": "Monako",
  "MD": "Moldova",
  "ME": "Karadağ",
  "MF": "Saint Martin (Fransız Bölgesi)",
  "MG": "Madagaskar",
  "MH": "Marshall Adaları",
  "MK": "Kuzey Makedonya",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Moğolistan",
  "MO": "Makao",
  "MP": "Kuzey Mariana Adaları",
  "MQ": "Martinik",
  "MR": "Moritanya",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldivler",
  "MW": "Malavi",
  "MX": "Meksika",
  "MY": "Malezya",
  "MZ": "Mozambik",
  "NA": "Namibya",
  "NC": "Yeni Kaledonya",
  "NE": "Nijer",
  "NF": "Norfolk Adası",
  "NG": "Nijerya",
  "NI": "Nikaragua",
  "NL": "Hollanda",
  "NO": "Norveç",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "Yeni Zelanda",
  "OM": "Umman",
  "OS": "Güney Osetya",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "Fransız Polinezyası",
  "PG": "Papua Yeni Gine",
  "PH": "Filipinler",
  "PK": "Pakistan",
  "PL": "Polonya",
  "PM": "Saint Pierre ve Miquelon",
  "PN": "Pitcairn",
  "PR": "Porto Riko",
  "PS": "Filistin",
  "PT": "Portekiz",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Katar",
  "RE": "Yeniden Birleşme",
  "RO": "Romanya",
  "RS": "Sırbistan",
  "RU": "Rusya",
  "RW": "Ruanda",
  "SA": "Suudi Arabistan",
  "SB": "Solomon Adaları",
  "SC": "Seyşeller",
  "SD": "Sudan",
  "SE": "İsveç",
  "SG": "Singapur",
  "SH": "Aziz Helena",
  "SI": "Slovenya",
  "SJ": "Svalbard ve Jan Mayen",
  "SK": "Slovakya",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somali",
  "SR": "Surinam",
  "SS": "Güney Sudan",
  "ST": "Sao Tome ve Principe",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Suriye",
  "SZ": "Svaziland",
  "TA": "Tristan da Cunha",
  "TC": "Turks ve Caicos Adaları",
  "TD": "Çad",
  "TF": "Fransız Güney Toprakları",
  "TG": "Togo",
  "TH": "Tayland",
  "TJ": "Tacikistan",
  "TK": "Tokelau",
  "TL": "Doğu Timor",
  "TM": "Türkmenistan",
  "TN": "Tunus",
  "TO": "Tonga",
  "TR": "Türkiye",
  "TT": "Trinidad ve Tobago",
  "TV": "Tuvalu",
  "TW": "Tayvan",
  "TZ": "Tanzanya",
  "UA": "Ukrayna",
  "UG": "Uganda",
  "UM": "Amerika Birleşik Devletleri Minor Uzak Adalar",
  "US": "Amerika Birleşik Devletleri",
  "UY": "Uruguay",
  "UZ": "Özbekistan",
  "VA": "Holy See (Vatikan Şehir Devleti)",
  "VC": "Saint Vincent ve Grenadinler",
  "VE": "Venezuela",
  "VG": "Virgin Adaları, İngiliz",
  "VI": "Virgin Adaları, ABD",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WF": "Wallis ve Futuna",
  "WS": "Samoa",
  "XK": "Kosova",
  "YE": "Yemen",
  "YT": "Mayotte",
  "ZA": "Güney Afrika",
  "ZM": "Zambiya",
  "ZW": "Zimbabve",
  "ZZ": "Uluslararası"
}